import * as React from "react";
import { DoneButton } from "@deliverr/ui-facility/lib-facility/components";
import { useConfirmBulkTransfer } from "./useConfirmBulkTransfer";

export const ConfirmBulkTransferButton: React.FC = () => {
  const { onClick, disabled } = useConfirmBulkTransfer();
  return <DoneButton onClick={onClick} disabled={disabled} block />;
};
